module.exports = __webpack_public_path__ + "static/media/O.fc6ebdbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/O.jpg
// module id = 83
// module chunks = 0